import React, { useState } from 'react';
import { func, object, string } from 'prop-types';
import {injectIntl, intlShape} from 'react-intl';
import classNames from 'classnames';
import {compose} from "redux";
import {connect} from "react-redux";

import css from './DiscountCode.module.css';
import { IconCheck, IconError } from '../../../components/Icons';
import {verifyDiscountCode} from "../../../containers/CheckoutPage/CheckoutPage.duck";
import {PrimaryButton} from "../../../components";

const DiscountCode = (props) => {
  const { className, discount, errorVerifyDiscountCode, intl, isLoadingVerifyDiscountCode, onVerifyDiscountCode, pageData = {} } =
    props;
  const { bookingData, listing, transaction } = pageData;
  const [code, setCode] = useState(discount.code || '');
  const handleChange = (e) => {
    setCode(e.target.value);
  };
  const orderParams = listing && transaction && {
    listingId: listing.id.uuid,
    bookingStart: bookingData.bookingStart,
    bookingEnd: bookingData.bookingEnd,
    protectedData: {
      date: bookingData.bookingStart,
      endDate: bookingData.bookingEnd,
      quantity: bookingData.quantity,
      quantityHours: bookingData.quantityHours,
      extras: bookingData.extras,
    },
    canApplyCommissionDiscountOnBigBookings: false,
  };
  const showStatusText = discount.code || errorVerifyDiscountCode;
  const headingText = intl.formatMessage({ id: 'StripePaymentForm.DiscountCode.heading' });
  const placeholder = intl.formatMessage({ id: 'StripePaymentForm.DiscountCode.placeholder' });
  const statusText = intl.formatMessage({
    id: `StripePaymentForm.DiscountCode.${discount.code ? 'valid' : 'invalid'}`,
  }, { percent: discount?.percentage});
  const submitButtonText = intl.formatMessage({ id: 'Marketplace.apply' });
  const classes = classNames(css.root, className);
  const statusClasses = classNames(css.statusWrapper, discount.code ? css.valid : css.invalid);

  return (
    <div className={classes}>
      <h3 className={css.heading}>{headingText}</h3>
      <div className={css.inputWrapper}>
        <input className={css.input} type="text" onChange={handleChange} value={code} placeholder={placeholder} />
        <PrimaryButton
          className={css.submitButton}
          inProgress={isLoadingVerifyDiscountCode}
          type="button"
          onClick={() =>
            onVerifyDiscountCode({
              discountCode: code,
              orderParams,
              transactionId: transaction?.id,
            })
          }
        >
          <span>{submitButtonText}</span>
        </PrimaryButton>
      </div>
      {showStatusText && (
        <div className={statusClasses}>
          {errorVerifyDiscountCode ? (
            <IconError className={css.iconError} />
          ) : (
            <IconCheck className={css.iconCheck} />
          )}
          <span className={css.status}>{statusText}</span>
        </div>
      )}
    </div>
  );
};

DiscountCode.defaultProps = {
  className: null,
  discount: {},
  errorVerifyDiscountCode: null,
};

DiscountCode.propTypes = {
  className: string,
  discount: object,
  errorVerifyDiscountCode: object,
  intl: intlShape.isRequired,
  onVerifyDiscountCode: func.isRequired,
  pageData: object.isRequired,
};


const mapStateToProps = state => {
  const {
    errorVerifyDiscountCode,
    isLoadingVerifyDiscountCode,
  } = state.CheckoutPage;

  return {
    errorVerifyDiscountCode,
    isLoadingVerifyDiscountCode
  };
};

const mapDispatchToProps = dispatch => ({
  onVerifyDiscountCode: (params) => dispatch(verifyDiscountCode(params)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)(DiscountCode);
